// extracted by mini-css-extract-plugin
module.exports = {"LOADING_STYLES":"LoadingPage_LOADING_STYLES__aoZvz","LOADING_ANIMATION_CONTAINER":"LoadingPage_LOADING_ANIMATION_CONTAINER__3WUYy"};